import { PropsWithChildren } from "react";
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseDisclosureProps,
} from "@chakra-ui/react";

export type RequestModalProps = Pick<UseDisclosureProps, "onClose" | "isOpen">;

const RequestModal = ({
  isOpen,
  onClose = () => {
    return;
  },
  canDismiss = true,
  header,
  children,
}: PropsWithChildren<
  RequestModalProps & {
    canDismiss?: boolean;
    header?: string | JSX.Element;
  }
>) => (
  <Modal
    isCentered
    isOpen={isOpen as boolean}
    onClose={onClose}
    size="xl"
    closeOnOverlayClick={canDismiss}
  >
    <ModalOverlay />
    <ModalContent mx={4}>
      {header ? <ModalHeader pt={6}>{header}</ModalHeader> : null}
      {canDismiss ? <ModalCloseButton /> : null}
      {children}
    </ModalContent>
  </Modal>
);
export default RequestModal;
